import { SharedConstants } from "../../../../../../../afla-common/src/lib/constants/shared-constants";
export class ViewApplicationDetailsAConstants {
    static STEP_TITLE = "Details";
    static APPLICATION_DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_LABEL = "Description";
    static IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL = "Is the advertising permanent or temporary?";
    static APPLICATION_TYPE_LABEL = "Application type";
    static APPLICATION_DURATION_LABEL = "Application duration";
    static DISPLAY_START_DATE_LABEL = "Display start date";
    static DISPLAY_END_DATE_LABEL = "Display end date";
    static DISPLAY_REMOVAL_DATE_LABEL = "Display removal date";
    static NUMBER_OF_POSTERS_LABEL = "Number of posters / banners / flags";
    static NAME_OF_BUSINESS_LABEL = "Name of business";
    static NOTIFY_SIGNAGE_REMOVAL_LABEL = "Notify the municipality within this period of signage is removed?";
    static POSITION_OF_THE_DISPLAY_LABEL = "Position of the display";
    static HEIGHT_LABEL = "Height(m)";
    static WIDTH_LABEL = "Width(m)";
    static DEPTH_LABEL = "Depth(m)";
    static MATERIAL_LABEL = "Material";
    static COLOURS_LABEL = "Colours";
    static FRONTAL_AREA_LABEL = `Frontal area (m2)`;
    static TOTAL_AREA_LABEL = `Total area (m2)`;
    static SIGN_TYPE_LABEL = "Sign type";
    static WEIGHT_LABEL = "Weight (kg)";
    static WATTAGE_LABEL = "Wattage";
    static SIGN_CONTRACTOR_LABEL = "Sign contractor name";
    static SIGN_CONTRACTOR_ADDRESS_LABEL = "Sign contractor address";
    static SIGN_CONTRACTOR_TELEPHONE_LABEL = "Sign contractor telephone number";
    // 1 year permanent
    static FOR_SALE_LABEL = "For sale";
    static ON_SHOW_LABEL = "On show";
    static TO_LET_LABEL = "To-Let";
    static SOLD_LABEL = "Sold";
    static CONSTRUCTION_BOARD_SIGN_LABEL = "Construction board sign";
    static OTHER_LABEL = "Other";
    // 5 year permanent
    static GROUND_SIGN_FORM_LABEL = "Ground sign";
    static FLAG_FORM_LABEL = "Flag";
    static SANDWICH_BOARD_FORM_LABEL = "Sandwich board";
    static PYLON_FORM_LABEL = "Pylon";
    static WALL_SIGN_FORM_LABEL = "Wall sign";
    static BUILDING_ATTACHMENT_LABEL = "Building attachment";
    static PROJECTING_WALL_SIGN_LABEL = "Projecting wall sign";
    static WALL_PAINTED_LABEL = "Wall painted";
    static ROOF_SIGN_LABEL = "Roof sign";
    static SKY_SIGN_LABEL = "Sky sign";
    static VERANDA_LABEL = "Veranda";
    static AERIAL_SIGN_LABEL = "Aerial sign";
    static WINDOW_SIGN_LABEL = "Window sign";
    static SCHOOL_SIGN_LABEL = "School sign";
    static COMBINATION_SIGN_LABEL = "Combination sign";
    static UNDER_AWNING_SIGN_LABEL = "Under awning sign";
    static FLAG_SIGN_LABEL = "Flag sign";
    static CANOPY_LABEL = "Canopy";
    static BALCONY_LABEL = "Balcony";
    static ELECTRONIC_SIGN_LABEL = "Electronic sign (Excluding billboards / Gantries)";
    static DEVELOPMENT_BOARD_LABEL = "Development board";
    static OTHER_FIVE_YEAR_LABEL = "Other (specify)";
    static NON_ILLUMINATED_BILLBOARD_LABEL = "Non-Illuminated billboard";
    static DIGITAL_BILLBOARD_LABEL = "Digital billboard";
    static NON_ILLUMINATED_GANTRY_LABEL = "Non-Illuminated gantry";
    static DIGITAL_GANTRY_LABEL = "Digital Gantry";
    static INTERNALLY_ILLUMINATED_BILLBOARD_LABEL = "Internally illuminated billboard";
    static INTERNALLY_ILLUMINATED_GANTRY_LABEL = "Internally illuminated gantry";
    // Temporary ApplicationType Labels
    static MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_LABEL = "Municipal consumer account number";
    static PERSON_RESPONSIBLE_CONTROL_LABEL = "Person responsible";
    static ADVERTISEMENTS_FORM_GROUP_NAME = "advertisementsForm";
    static ADVERTISEMENTS_FORM_CONTROL_NAME = "advertisements";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME = "isAdvetisingPermanentOrTemporary";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static APPLICATION_DURATION_FORM_CONTROL_NAME = "permanentApplicationDuration";
    static DISPLAY_START_DATE_FORM_CONTROL_NAME = "displayStartDate";
    static DISPLAY_END_DATE_FORM_CONTROL_NAME = "displayEndDate";
    static DISPLAY_REMOVAL_DATE_FORM_CONTROL_NAME = "displayRemovalDate";
    static NUMBER_OF_POSTERS_FORM_CONTROL_NAME = "numberOfPosters";
    static NAME_OF_BUSINESS_FORM_CONTROL_NAME = "nameOfBusiness";
    static NOTIFY_SIGNAGE_REMOVAL_PERIOD_FORM_CONTROL_NAME = "notifySignageRemovalPeriod";
    static POSITION_OF_DISPLAY_FORM_CONTROL_NAME = "positionOfDisplay";
    static HEIGHT_FORM_CONTROL_NAME = "dimensionsH";
    static WIDTH_FORM_CONTROL_NAME = "dimensionsW";
    static DEPTH_FORM_CONTROL_NAME = "dimensionsD";
    static MATERIAL_FORM_CONTROL_NAME = "material";
    static COLOURS_FORM_CONTROL_NAME = "colours";
    static FRONTAL_AREA_FORM_CONTROL_NAME = "frontalArea";
    static TOTAL_AREA_FORM_CONTROL_NAME = "totalArea";
    static SIGN_TYPE_FORM_CONTROL_NAME = "signType";
    static WEIGHT_FORM_CONTROL_NAME = "weight";
    static WATTAGE_FORM_CONTROL_NAME = "wattage";
    static SIGN_CONTRACTOR_NAME_FORM_CONTROL_NAME = "contractorName";
    static SIGN_CONTRACTOR_ADDRESS_FORM_CONTROL_NAME = "contractorAddress";
    static SIGN_CONTRACTOR_TELEPHONE_FORM_CONTROL_NAME = "contractorTelephone";
    static FOR_SALE_FORM_CONTROL_NAME = "forSale";
    static ON_SHOW_FORM_CONTROL_NAME = "onShow";
    static TO_LET_FORM_CONTROL_NAME = "toLet";
    static SOLD_FORM_CONTROL_NAME = "sold";
    static OTHER_FORM_CONTROL_NAME = "otherOneYear";
    static CONSTRUCTION_BOARD_SIGN_FORM_CONTROL_NAME = "constructionBoardSign";
    // 5year permanent
    static GROUND_SIGN_FORM_CONTROL_NAME = "groundSign";
    static FLAG_FORM_CONTROL_NAME = "flag";
    static SANDWICH_BOARD_FORM_CONTROL_NAME = "sandwichBoard";
    static PYLON_FORM_CONTROL_NAME = "pylon";
    static WALL_SIGN_FORM_CONTROL_NAME = "wallSign";
    static BILLBOARD_FORM_LABEL = "Billboard";
    static BILLBOARD_FORM_CONTROL_NAME = "billboard";
    static BUILDING_ATTACHMENT_FORM_CONTROL_NAME = "buildingAttachment";
    static PROJECTING_WALL_SIGN_FORM_CONTROL_NAME = "projectingWallSign";
    static WALL_PAINTED_FORM_CONTROL_NAME = "wallPainted";
    static ROOF_SIGN_FORM_CONTROL_NAME = "roofSign";
    static SKY_SIGN_FORM_CONTROL_NAME = "skySign";
    static VERANDA_FORM_CONTROL_NAME = "veranda";
    static AERIAL_SIGN_FORM_CONTROL_NAME = "aerialSign";
    static WINDOW_SIGN_FORM_CONTROL_NAME = "windowSign";
    static SCHOOL_SIGN_FORM_CONTROL_NAME = "schoolSign";
    static COMBINATION_SIGN_FORM_CONTROL_NAME = "combinationSign";
    static UNDER_AWNING_SIGN_FORM_CONTROL_NAME = "underAwningSign";
    static FLAG_SIGN_FORM_CONTROL_NAME = "flagSign";
    static CANOPY_FORM_CONTROL_NAME = "canopy";
    static BALCONY_FORM_CONTROL_NAME = "balcony";
    static ELECTRONIC_SIGN_FORM_CONTROL_NAME = "electronicSign";
    static DEVELOPMENT_BOARD_FORM_CONTROL_NAME = "developmentBoard";
    static OTHER_FIVE_YEAR_FORM_CONTROL_NAME = "otherFiveYear";
    static NON_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME = "nonIlluminatedBillboard";
    static DIGITAL_BILLBOARD_FORM_CONTROL_NAME = "digitalBillboard";
    static NON_ILLUMINATED_GANTRY_FORM_CONTROL_NAME = "nonIlluminatedGantry";
    static DIGITAL_GANTRY_FORM_CONTROL_NAME = "digitalGantry";
    static INTERNALLY_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME = "internallyIlluminatedBillboard";
    static INTERNALLY_ILLUMINATED_GANTRY_FORM_CONTROL_NAME = "internallyIlluminatedGantry";
    static MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_FORM_CONTROL_NAME = "municipalConsumerAccountNumber";
    static MODAL_DIALOG_TITLE = "Are you sure you want to change the advertisement type";
    static MODAL_DIALOG_MESSAGE = "Changing the advertisement type will erase all the information that has already been captured in the location details. Do you want to continue changing the advertisement type?";
    static MODAL_OPTIONS = {
        size: "xl",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
    // Permanent ApplicationType Controls
    static MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_CONTROL_NAME = "municipalConsumerAccountNumber";
    static PERSON_RESPONSIBLE_CONTROL_NAME = "personResponsible";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isAdvertisingPermanentOrTemporary: {
            required: `is advertising permanent or temporary ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationDuration: {
            required: `Application duration ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        displayStartDate: {
            required: `Display start date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        displayEndDate: {
            required: `Display end date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        displayRemovalDate: {
            required: `Display removal date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        whoIsApplying: {
            required: `who is applying ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        numberOfPosters: {
            required: `Number of posters ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        nameOfBusiness: {
            required: `Name of business ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        notifySignageRemovalPeriod: {
            required: `Notify signage removal period ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        positionOfTheDisplay: {
            required: `Position of the display ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        height: {
            required: `Height ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        width: {
            required: `Width ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        depth: {
            required: `Depth ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        material: {
            required: `Material ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        colours: {
            required: `Colours ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        frontalArea: {
            required: `Frontal area ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalArea: {
            required: `Frontal area ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        signType: {
            required: `Sign type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        weight: {
            required: `Weight ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        wattage: {
            required: `Wattage ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        signContractor: {
            required: `Sign contractor name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        signContractorAddress: {
            required: `Sign contractor address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        signContractorTelephone: {
            required: `Sign contractor telephone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        nonIlluminatedBillboard: {
            required: `Non-Illuminated billboard ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        digitalBillboard: {
            required: `Digital billboard ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        nonIlluminatedGantry: {
            required: `Non-Illuminated gantry ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        digitalGantry: {
            required: `digital gantry ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        internallyIlluminatedBillboard: {
            required: `Internally illuminated billboard ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        internallyIlluminatedGantry: {
            required: `Internally illuminated gantry ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        municipalConsumerAccountNumber: {
            required: `Municipal consumer account number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
